// DisciplinaryCharts.js

import React from "react";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip,
  PieChart, Pie, Cell,
  LineChart, Line, CartesianGrid
} from "recharts";

// UPDATED: Added more colors for a better visual distribution
const COLORS = [
  "#FFA500", // Orange
  "#FF6347", // Tomato
  "#FFD700", // Gold
  "#32CD32", // LimeGreen
  "#4169E1", // RoyalBlue
  "#8A2BE2", // BlueViolet
  "#FF4500", // OrangeRed
  "#DAA520", // GoldenRod
  "#5F9EA0", // CadetBlue
  "#FF69B4", // HotPink
  "#BDB76B", // DarkKhaki
];

const DisciplinaryCharts = ({ cases, type }) => {
  if (!cases || cases.length === 0) {
    return <p className="text-gray-500 text-sm">No data available.</p>;
  }

  const departmentData = Object.values(
    cases.reduce((acc, curr) => {
      const dept = curr.department || "Unknown";
      acc[dept] = acc[dept] || { department: dept, count: 0 };
      acc[dept].count += 1;
      return acc;
    }, {})
  );

  const offenseTypeData = Object.values(
    cases.reduce((acc, curr) => {
      const offense = curr.offense || "Unknown";
      acc[offense] = acc[offense] || { offense: offense, count: 0 };
      acc[offense].count += 1;
      return acc;
    }, {})
  );

  const monthlyData = Object.values(
    cases.reduce((acc, curr) => {
      const dateStr = curr.dateReported;
      const month = dateStr
        ? new Date(dateStr).toLocaleString("default", { month: "short", year: "numeric" })
        : "Unknown";

      acc[month] = acc[month] || { month, count: 0 };
      acc[month].count += 1;
      return acc;
    }, {})
  );

  if (type === "departments") {
    return (
      <BarChart width={250} height={200} data={departmentData}>
        <XAxis dataKey="department" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="count" fill="#FFA500" />
      </BarChart>
    );
  }

  if (type === "offenses") {
    return (
      <PieChart width={250} height={200}>
        <Pie
          data={offenseTypeData}
          dataKey="count"
          nameKey="offense"
          cx="50%"
          cy="50%"
          outerRadius={60}
        // Removed 'label' to hide numbers/offense by default
        >
          {offenseTypeData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    );
  }

  if (type === "monthly") {
    return (
      <LineChart width={250} height={200} data={monthlyData}>
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
        <Line type="monotone" dataKey="count" stroke="#FF8C00" />
      </LineChart>
    );
  }

  return <p className="text-gray-500 text-sm">Invalid chart type.</p>;
};

export default DisciplinaryCharts;
